enum SubscriptionOpeningDays {
  weekdays = "weekdays",
  monSat = "mon-sat",
  tueSat = "tue-sat",
}

export const subscriptionOpeningDaysAsString = (
  subscriptionOpeningDays: SubscriptionOpeningDays
): string => {
  switch (subscriptionOpeningDays) {
    case SubscriptionOpeningDays.weekdays:
      return "Lundi → Vendredi";
    case SubscriptionOpeningDays.monSat:
      return "Lundi → Samedi";
    case SubscriptionOpeningDays.tueSat:
      return "Mardi → Samedi";
    default:
      return "";
  }
};

export default SubscriptionOpeningDays;
